import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDrag } from "react-dnd";
import { IAsset } from "../../../../../../stateManager/store/formCreation_v2/types";
import { useToast } from "../../../../../../helpers/commonFunction";
import { ItemTypes } from "../../types/ItemTypes";
import style from "./style.module.css";
import { setAssetEditMode } from "../../../../../../stateManager/store/formCreation_v2/actions";

// icons
import { ReactComponent as DeleteIcon } from "../../../../../../assets/svg/solobuilder/delete.svg";
import { ReactComponent as EditIcon } from "../../../../../../assets/svg/solobuilder/edit.svg";
import { ReactComponent as CopyIcon } from "../../../../../../assets/svg/solobuilder/copy.svg";
import {AppState} from "../../../../../../stateManager/store";

interface IComponent {
  asset: IAsset;
  assetId: string;
  openModal: () => void;
  setAsset: (data: any) => void;
}

export const Component: React.FC<IComponent> = ({
  asset,
  assetId,
  openModal,
  setAsset,
}) => {
  const dispatch = useDispatch();
  const { SuccessToast } = useToast();
  const { label, id } = asset;
  const { isAssetInstanceSelected, assetEditModeEnabled } = useSelector((state: AppState) => {
    const formJson = state.formJson
    return {
      assets : formJson.assets,
      isAssetInstanceSelected: formJson.isAssetInstanceSelected,
      assetEditModeEnabled: formJson.assetEditMode.isEnabled
    }
  })

  let assetParentType
  if (asset?.json?.components && asset?.json?.componentOrder?.length) {
    assetParentType = asset.json.components[asset.json.componentOrder[0]]?.type;
  } else {
    assetParentType = "none";
  }
  const [{ isDragging }, drag] = useDrag({
    item: {
      type: ItemTypes.ASSET,
      json: {
        assetId,
        type: assetParentType
      },
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const opacity = isDragging ? 0.4 : 1;

  const handleEditAsset = () => {
    dispatch(setAssetEditMode({ assetId, isEnabled: true }));
  };

  const handleDelete = () => {
    setAsset({ id, assetId });
    openModal();
  };

  const handleCopyId = async () => {
    await navigator.clipboard.writeText(assetId);
    SuccessToast("Copied Asset ID");
  };

  return (
    <div className={`${!assetEditModeEnabled && style.asset}`} ref={drag} style={{opacity, padding:"8px 10px", paddingLeft:"24px" }}>
      <p
        style={{
          color: "#282B31",
          fontSize: 16,
        }}
      >
        {label}
      </p>
      <div className="flex gap-8 hidden pr-2">
        <CopyIcon
          className="h-7 w-7 center cursor-pointer"
          onClick={handleCopyId}
          style={{ stroke: "#292D32" }}
        />
        <EditIcon
          className="h-7 w-7 center cursor-pointer"
          style={{ stroke: "#292D32" }}
          onClick={handleEditAsset}
        />
        <DeleteIcon className="h-7 w-7 cursor-pointer" style={{ stroke: "#F32727" }} onClick={handleDelete} />
      </div>
    </div>
  );
};
